import { render, staticRenderFns } from "./JumpcloudWordmark.vue?vue&type=template&id=1dc25b52"
import script from "./JumpcloudWordmark.vue?vue&type=script&lang=js"
export * from "./JumpcloudWordmark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports